import * as React from 'react';
import './Loading.css';
const loading = require('./loading.svg') as string;

interface LoadingIndicatorProps {
    showBackground?: boolean;
}

export class LoadingIndicatorMini extends React.Component<LoadingIndicatorProps> {
    render() {
        return (
            <div className="loading-container mini">
                <img src={loading} alt="loading" />
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/loadingIndicator/LoadingIndicatorMini.tsx